var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-switch',{attrs:{"active-text":'Verteiler ' + _vm.listname},on:{"change":_vm.toggleList},model:{value:(_vm.fields.mailinglistactive),callback:function ($$v) {_vm.$set(_vm.fields, "mailinglistactive", $$v)},expression:"fields.mailinglistactive"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }